import axios from 'axios';

// The server ends a login when the user is deleted, renamed, or their password is changed
// (401 with { sessionEnded: true }). Clear the cookie and go to the login page, once.
let redirecting = false;

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401 && error.response?.data?.sessionEnded && !redirecting && window.location.pathname !== '/') {
            redirecting = true;
            axios.post(`${window.backendUrl}/logout`, {}, { withCredentials: true })
                .catch(() => {})
                .finally(() => {
                    alert('You were logged out: your password was changed or your account was removed. Please log in again.');
                    window.location.href = '/';
                });
        }
        return Promise.reject(error);
    }
);
